import { __awaiter } from 'tslib';
import 'long';
import { im_proto } from '../../proto/index.js';
import '../../core/consts.js';
import '../../core/metrics/logger.js';
import { BaseApiManager } from '../../core/plugin/BaseApiManager.js';
import '../../core/metrics/monitor.js';
import '../../core/service/RuntimeContext.js';
import 'json-long';
import 'moize';
import '../../core/model/Message.js';
import 'js-md5';
import '../../core/utils/lz4.js';
import '../../core/utils/serializer.js';
import '../../core/network/NetworkItem.js';
import '../../adapter/manager/AdapterManager.js';
import '../../adapter/manager/types.js';
import '../../core/utils/ticker.js';
import '../../adapter/abstract/IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import '../../core/metrics/trackerTypes.js';
import '../../core/model/CommandMessage.js';

class ExtensionApiManager extends BaseApiManager {
    LeaveConversation(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                leave_conversation_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType
                }
            });
            return this.send(reqBody, im_proto.IMCMD.LEAVE_CONVERSATION, { inboxType: params.inboxType });
        });
    }
    DeleteMessage(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                delete_message_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    message_id: params.serverId
                }
            });
            return this.send(reqBody, im_proto.IMCMD.DELETE_MESSAGE, { inboxType: params.inboxType });
        });
    }
    GetMessageByServerId(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                get_message_by_id_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    server_message_id: params.serverId
                }
            });
            return this.sendWithRawBody(reqBody, im_proto.IMCMD.GET_MESSAGE_INFO_BY_SERVER_ID, {
                inboxType: params.inboxType
            });
        });
    }
    MarkConversationDelete(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                delete_conversation_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    last_message_index: params.lastPullIndex
                }
            });
            return this.send(reqBody, im_proto.IMCMD.MARK_CONVERSATION_DELETE, { inboxType: params.inboxType });
        });
    }
    AddConversationParticipants(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                conversation_add_participants_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    participants: params.participants,
                    biz_ext: params.bizExt
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.ADD_CONVERSATION_PARTICIPANTS, { inboxType: params.inboxType }))
                .conversation_add_participants_body;
        });
    }
    GetConversationInfoListByFavoriteV2(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                get_conversation_info_list_by_favorite_v2_body: {
                    cursor: params.cursor,
                    limit: params.limit
                }
            });
            return this.sendWithRawBody(reqBody, im_proto.IMCMD.GET_CONVERSATION_INFO_LIST_BY_FAVORITE_V2, {
                inboxType: params.inboxType
            });
        });
    }
    GetConversationInfoListByTopV2(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                get_conversation_info_list_by_top_v2_body: {
                    cursor: params.cursor,
                    limit: params.limit
                }
            });
            return this.sendWithRawBody(reqBody, im_proto.IMCMD.GET_CONVERSATION_INFO_LIST_BY_TOP_V2, {
                inboxType: params.inboxType
            });
        });
    }
    UpdateConversationParticipant(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                update_conversation_participant_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    user_id: params.userId,
                    role: params.role,
                    alias: params.alias,
                    biz_ext: params.bizExt,
                    is_alias_set: Boolean(params.alias)
                }
            });
            return this.sendWithRawBody(reqBody, im_proto.IMCMD.UPDATE_CONVERSATION_PARTICIPANT, {
                inboxType: params.inboxType
            });
        });
    }
    SetConversationCoreInfo(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                set_conversation_core_info_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    name: params.name,
                    desc: params.desc,
                    icon: params.icon,
                    notice: params.notice,
                    ext: params.ext,
                    biz_ext: params.bizExt
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.SET_CONVERSATION_CORE_INFO, { inboxType: params.inboxType }))
                .set_conversation_core_info_body;
        });
    }
    RemoveConversationParticipants(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                conversation_remove_participants_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    participants: params.participants,
                    biz_ext: params.bizExt
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.REMOVE_CONVERSATION_PARTICIPANTS, { inboxType: params.inboxType })).conversation_remove_participants_body;
        });
    }
    UpsertConversationCoreExtInfo(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                upsert_conversation_core_ext_info_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    ext: params.ext
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.UPSERT_CONVERSATION_CORE_EXT_INFO, { inboxType: params.inboxType })).upsert_conversation_core_ext_info_body;
        });
    }
    SetConversationSettingInfo(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                set_conversation_setting_info_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    set_stick_on_top: params.stickOnTop,
                    set_mute: params.mute,
                    set_favorite: params.favorite,
                    push_status: params.pushStatus
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.SET_CONVERSATION_SETTING_INFO, { inboxType: params.inboxType }))
                .set_conversation_setting_info_body;
        });
    }
    UpsertConversationSettingExtInfo(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                upsert_conversation_setting_ext_info_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    ext: params.ext
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.UPSERT_CONVERSATION_SETTING_EXT_INFO, {
                inboxType: params.inboxType
            })).upsert_conversation_setting_ext_info_body;
        });
    }
    GetConversationParticipantsReadIndexV3(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                participants_read_index_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.GET_CONVERSATION_PARTICIPANTS_READ_INDEX_V3, {
                inboxType: params.inboxType
            })).participants_read_index_body;
        });
    }
    GetConversationParticipantsMinIndexV3(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                participants_min_index_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.GET_CONVERSATION_PARTICIPANTS_MIN_INDEX_V3, {
                inboxType: params.inboxType
            })).participants_min_index_body;
        });
    }
    GetConversationParticipantsList(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                conversation_participants_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    cursor: params.cursor,
                    limit: params.limit
                }
            });
            return this.sendWithRawBody(reqBody, im_proto.IMCMD.CONVERSATION_PARTICIPANTS_LIST, {
                inboxType: params.inboxType
            });
        });
    }
    SendUserAction(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                send_user_action_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    action_type: params.actionType,
                    extra: params.extra
                }
            });
            return this.send(reqBody, im_proto.IMCMD.SEND_USER_ACTION, { inboxType: params.inboxType });
        });
    }
    SendInputStatus(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                send_input_status_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    status: params.status,
                    extra: params.extra
                }
            });
            return this.send(reqBody, im_proto.IMCMD.SEND_INPUT_STATUS, { inboxType: params.inboxType });
        });
    }
    DissolveConversation(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                dissolve_conversation_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType
                }
            });
            return this.send(reqBody, im_proto.IMCMD.DISSOLVE_CONVERSATION, { inboxType: params.inboxType });
        });
    }
    ModifyMessageExt(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                modify_message_ext_body: {
                    conversation_short_id: params.conversationShortId,
                    message_id: params.messageId,
                    ticket: params.ticket,
                    ext: params.ext
                }
            });
            return this.send(reqBody, im_proto.IMCMD.MODIFY_MESSAGE_EXT, { inboxType: params.inboxType });
        });
    }
    GetUserConversationList(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                get_conversation_list_body: {
                    con_type: params.type,
                    cursor: params.cursor,
                    limit: params.limit,
                    sort_type: params.sortType,
                    include_role: params.includeRole,
                    exclude_role: params.excludeRole,
                    with_cold: params.withCold,
                    push_status: params.pushStatus
                }
            });
            return this.sendWithRawBody(reqBody, im_proto.IMCMD.GET_USER_CONVERSATION_LIST, { inboxType: params.inboxType });
        });
    }
    UnreadCountReport(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                unread_count_report_body: {
                    conv_unread_count: params.conv.map(c => ({
                        conv_short_id: c.shortId,
                        conversation_type: c.type,
                        unread_count: c.count
                    })),
                    total_unread_count: params.total
                }
            });
            return this.send(reqBody, im_proto.IMCMD.UNREAD_COUNT_REPORT, { inboxType: params.inboxType });
        });
    }
    BlockConversation(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                block_conversation_body: {
                    conversation_id: params.conversationId,
                    conv_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    block_status: params.status,
                    block_normal_only: params.normalOnly
                }
            });
            return this.send(reqBody, im_proto.IMCMD.BLOCK_CONVERSATION, { inboxType: params.inboxType });
        });
    }
    BlockMember(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                block_members_body: {
                    conversation_id: params.conversationId,
                    conv_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    block_time: params.time,
                    block_status: params.status,
                    biz_ext: params.bizExt
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.BLOCK_MEMBERS, { inboxType: params.inboxType }))
                .block_members_body;
        });
    }
    GetBlockList(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                get_blocklist_body: {
                    cursor: params.cursor,
                    limit: params.limit
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.GET_BLOCKLIST, { inboxType: params.inboxType }))
                .get_blocklist_body;
        });
    }
    SetBlockList(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                set_blocklist_body: {
                    set_block_list: params.applySet,
                    blocklist: params.blocklist
                }
            });
            return this.send(reqBody, im_proto.IMCMD.SET_BLOCKLIST, { inboxType: params.inboxType });
        });
    }
    CheckInBlockList(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                check_in_blocklist_body: {
                    user_to_check: params.userToCheck
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.CHECK_IN_BLOCKLIST, { inboxType: params.inboxType }))
                .check_in_blocklist_body;
        });
    }
    BroadcastSendMessage(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                broadcast_send_message_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    ticket: params.ticket,
                    message_type: params.type,
                    content: params.content,
                    client_message_id: params.clientId,
                    mentioned_users: params.mentionedUsers,
                    ext: params.ext
                }
            });
            return this.sendWithRawBody(reqBody, im_proto.IMCMD.BROADCAST_SEND_MESSAGE, { inboxType: params.inboxType });
        });
    }
    BroadcastReceiveMessage(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                broadcast_recv_message_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    cursor: params.cursor,
                    limit: params.limit,
                    reverse: params.reverse,
                    pull_type: params.pullType
                }
            });
            return this.sendWithRawBody(reqBody, im_proto.IMCMD.BROADCAST_RECV_MESSAGE, { inboxType: params.inboxType });
        });
    }
    BroadcastUserCounter(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                broadcast_user_counter_body: {
                    conversations: params.conversations.map(c => ({
                        conversation_short_id: c.shortId,
                        conversation_type: c.type
                    }))
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.BROADCAST_USER_COUNTER)).broadcast_user_counter_body;
        });
    }
    SendP2PMessage(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                send_message_p2p_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    send_type: params.sendType,
                    message_type: params.msgType,
                    content: params.content,
                    client_message_id: params.clientId,
                    ext: params.ext,
                    visible_user: params.visibleUser,
                    invisible_user: params.invisibleUser
                }
            });
            return this.send(reqBody, im_proto.IMCMD.SEND_MESSAGE_P2P, {
                useBeacon: true,
                maxRetryTimes: 1
            });
        });
    }
    ModifyMessageProperty(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                modify_message_property_body: {
                    property_list: {
                        conversation_id: params.conversationId,
                        conversation_short_id: params.conversationShortId,
                        conversation_type: params.conversationType,
                        server_message_id: params.serverId,
                        client_message_id: params.clientId,
                        modify_property_content: params.modifyContent.map(m => ({
                            operation: m.operation,
                            key: m.key,
                            value: m.value,
                            idempotent_id: m.idempotentId
                        }))
                    },
                    ticket: params.ticket
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.SET_MESSAGE_PROPERTY, { inboxType: params.inboxType }))
                .modify_message_property_body;
        });
    }
    GetUnreadCount(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                get_unread_count_body: {
                    get_total: params.total,
                    conv_short_id: params.shortIds
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.GET_UNREAD_COUNT, { inboxType: params.inboxType }))
                .get_unread_count_body;
        });
    }
    MarkMessage(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                mark_message_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    server_message_id: params.serverMessageId,
                    do_action: params.doAction,
                    action_type: params.actionType,
                    sort_time: params.sortTime,
                    tag: params.tag
                }
            });
            return this.send(reqBody, im_proto.IMCMD.MARK_MESSAGE, { inboxType: params.inboxType });
        });
    }
    PullMarkMessage(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                pull_mark_message_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    cursor: params.cursor,
                    limit: params.limit,
                    asc: params.asc,
                    action_type: params.actionType,
                    tag: params.tag
                }
            });
            return this.sendWithRawBody(reqBody, im_proto.IMCMD.PULL_MARK_MESSAGE, { inboxType: params.inboxType });
        });
    }
    GetConversationCoreInfo(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                get_conversation_core_info_body: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType
                }
            });
            return this.send(reqBody, im_proto.IMCMD.GET_CONVERSATION_CORE_INFO, { inboxType: params.inboxType });
        });
    }
    BatchUnmarkMessage(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                batch_unmark_message: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    server_message_ids: params.serverMessageIds,
                    action_type: params.actionType,
                    tag: params.tag
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.BATCH_UNMARK_MESSAGE)).batch_unmark_message;
        });
    }
    MarkMsgUnreadCountReport(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                mark_msg_unread_count_report: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    total_unread_count: params.totalUnreadCount,
                    tag_unread_count: params.tagUnreadCount
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.MARK_MSG_UNREAD_COUNT_REPORT)).mark_msg_unread_count_report;
        });
    }
    MarkMsgGetUnreadCount(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                mark_msg_get_unread_count: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    conversation_type: params.conversationType,
                    get_total: params.getTotal,
                    tags: params.tags
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.MARK_MSG_GET_UNREAD_COUNT)).mark_msg_get_unread_count;
        });
    }
    ConvertVoiceToText(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                audio_recognition_body: {
                    audio: {
                        content: params.content,
                        uid: params.uid,
                        server_message_id: params.server_message_id,
                        audio_option: params.audioOptions,
                        conv_short_id: params.conv_short_id
                    }
                }
            });
            return this.send(reqBody, im_proto.IMCMD.AUDIO_RECOGNITION);
        });
    }
    BatchGetConversationParticipantsReadIndex(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                batch_get_conversation_participants_readindex: {
                    conversation_id: params.conversationId,
                    conversation_short_id: params.conversationShortId,
                    request_from: params.request_from,
                    min_index_required: params.min_index_required
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.BATCH_GAT_CONVERSATION_PARTICIPANTS_READINDEX))
                .batch_get_conversation_participants_readindex;
        });
    }
}

export { ExtensionApiManager };
//# sourceMappingURL=ExtensionApiManager.js.map
